jQuery(document).ready(function ($) {
    var ajax_url = 'https://api.icepick.co/bamboo_stickers/index.php';
      
    if (customPricingData == null) {
      console.error('No custom pricing data found');
      return;
    }
  
    ///BUILD FORM
    if (customPricingData != null) {
      var sizeOptions = '',
        priceOptions = '',
        index = 0;
  
      $.each(customPricingData, function (key, value) {
        var checked = index == 0 ? 'checked' : '';
        sizeOptions +=
          '<label class="radio_list_item d-flex gap-2 align-items-center">' +
            '<div class="radio_list_input_wrapper">' +
              '<input type="radio" name="size" class="size_input" ' + checked + ' value="' + key + '">' +
              '<i></i>' +
            '</div>' +
            '<span class="radio_list_item_label">' + value.label + '</span>' +
          '</label>';
  
        if (index == 0) {
          var prices = value.prices;
          var priceKeys = Object.keys(prices);
          var halfLength = Math.ceil(priceKeys.length / 2);
  
          priceOptions += '<div class="row row-cols-1 row-cols-lg-2"><div class="col d-flex flex-column gap-2">';
  
          $.each(priceKeys, function (i, key) {
            var checked = i == 0 ? 'checked' : '',
              qty = key.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
            if (i == halfLength) {
              priceOptions += '</div><div class="col d-flex flex-column gap-2">';
            }
  
            priceOptions +=
              '<label class="radio_list_item d-flex gap-2 align-items-center qty_radio_wrapper">' +
                '<div class="radio_list_input_wrapper">' +
                  '<input type="radio" name="qty" class="qty_radio" data-price="' + prices[key] + '" data-final-price="' + prices[key] + '" ' + checked + ' value="' + key + '">' +
                  '<i></i>' +
                  '</div>' +
                '<span class="radio_list_item_label">' + qty + '</span>' +
                '<span class="radio_list_item_price">' + currency(prices[key]).format() + '</span>' +
              '</label>';
          });
  
          priceOptions += '</div></div>';
        }
  
        index++;
      });
  
      $('#size_options').html(sizeOptions);
      $('#qty_options').html(priceOptions);
  
      var price = $('[name="qty"]:checked').data('price');
      $('#price_input').val(price);
    }
  
    //size_input
    $(document).on('click', '.size_input', function () {
      var size = $(this).val(),
        prices = customPricingData[size].prices,
        priceOptions = '',
        priceKeys = Object.keys(prices),
        halfLength = Math.ceil(priceKeys.length / 2);
  
      priceOptions += '<div class="row row-cols-1 row-cols-lg-2"><div class="col d-flex flex-column gap-2">';
  
      $.each(priceKeys, function (i, key) {
        var checked = i == 0 ? 'checked' : '',
          qty = key.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
        if (i == halfLength) {
          priceOptions += '</div><div class="col d-flex flex-column gap-2">';
        }
  
        priceOptions +=
          '<label class="radio_list_item d-flex gap-2 align-items-center qty_radio_wrapper">' +
            '<div class="radio_list_input_wrapper">' +
              '<input type="radio" name="qty" class="qty_radio" data-qty="' + qty + '" data-price="' + prices[key] + '" data-final-price="' + prices[key] + '" ' + checked + ' value="' + key + '">' +
              '<i></i>' +
            '</div>' +
            '<span class="radio_list_item_label">' + qty + '</span>' +
            '<span class="radio_list_item_price">' + currency(prices[key]).format() + '</span>' +
          '</label>';
      });
  
      priceOptions += '</div></div>';
      $('#qty_options').html(priceOptions);
  
      var price = $('[name="qty"]:checked').data('price');
      $('#price_input').val(price);
    });
  
    //size_input
    $(document).on('click', '.qty_radio', function () {
      var price = $(this).data('final-price');
      $('#price_input').val(price);
    });
  
    //underlay_input
    $(document).on('click', '.underlay_input', function () {
      var v = $(this).val(),
          extra_cost = v == 'White Underlay' ? 0.10 : 0;
      
      $('.qty_radio').each(function(i, el){
        var qty = parseInt($(this).val()),
            price = $(this).data('price'),
            total_extra_cost = currency(extra_cost).multiply(qty).value,
            total_price = currency(price).add(total_extra_cost).value,
            label = $(this).closest('.radio_list_item').find('.radio_list_item_price');
  
        $(this).attr('data-final-price', total_price);
        $(this).data('final-price', total_price);
        $(label).text(currency(total_price).format());
      });
  
      var current_price = $('.qty_radio:checked').data('final-price');
      $('#price_input').val(current_price);
    });
  
    // Retry /cart/add.js — newly created variants need a moment to propagate from Admin API to storefront/inventory cache
    function addToCartWithRetry(add_data) {
      var MAX_ATTEMPTS = 6;
      var DELAYS = [0, 1500, 2000, 2500, 3000, 4000]; // total ~13s before giving up

      return new Promise(function (resolve, reject) {
        function attempt(i) {
          setTimeout(function () {
            $.post('/cart/add.js', add_data)
              .done(function (resp) { resolve(resp); })
              .fail(function (xhr, status, error) {
                var shouldRetry = (xhr.status === 422 || xhr.status === 404) && i < MAX_ATTEMPTS - 1;
                if (shouldRetry) {
                  console.warn('[cart/add] attempt ' + (i + 1) + '/' + MAX_ATTEMPTS + ' failed (HTTP ' + xhr.status + '), retrying in ' + DELAYS[i + 1] + 'ms');
                  attempt(i + 1);
                } else {
                  reject({ xhr: xhr, status: status, error: error });
                }
              });
          }, DELAYS[i]);
        }
        attempt(0);
      });
    }

    //custom_stickers_form
    $(document).on('submit', '#custom_stickers_form', function (e) {
      e.preventDefault();

      let form_data = $(this).serializeJSON();

      $.ajax({
        type: 'POST',
        url: ajax_url,
        data: {
          action: 'gw_createProduct',
          form_data: form_data,
        },
        dataType: 'json',
        beforeSend: function () {
          $('#custom_stickers_form').addClass('loading');
        },
        success: function (response) {
          // Check if the response is already an object (jQuery might have parsed it automatically)
          var parsedResponse;
          
          try {
            // If the response is a string, try to parse it as JSON
            if (typeof response === 'string') {
              // Check if the response contains HTML (PHP error)
              if (response.trim().startsWith('<')) {
                console.error('Server error (HTML response)');
                
                // Check if it contains a PHP error but also valid JSON at the end
                if (response.includes('<br />') && response.includes('{"status":')) {
                  // Extract the JSON part from the end of the response
                  const jsonStart = response.lastIndexOf('{');
                  const jsonPart = response.substring(jsonStart);
                  
                  try {
                    parsedResponse = JSON.parse(jsonPart);
                  } catch (e) {
                    console.error('Server error. Please try again later.');
                    $('#custom_stickers_form').removeClass('loading');
                    return false;
                  }
                } else {
                  console.error('Server error. Please try again later.');
                  $('#custom_stickers_form').removeClass('loading');
                  return false;
                }
              } else {
                parsedResponse = JSON.parse(response);
              }
            } else {
              // If it's already an object, use it directly
              parsedResponse = response;
            }
          } catch (e) {
            console.error('Error processing server response. Please try again.');
            $('#custom_stickers_form').removeClass('loading');
            return false;
          }

          // Check the response status
          if (parsedResponse.status !== 'success') {
            console.error('PHP response not success:', parsedResponse.message || 'Unknown error');
            $('#custom_stickers_form').removeClass('loading');
            return false;
          }

          // Continue with the normal process
          add_data = {
            items: [
              {
                id: parsedResponse.variant_id,
                quantity: 1,
                properties: {
                  Image: form_data.images,
                  Quantity: form_data.qty,
                  Size: form_data.size,
                  Shape: form_data.shape,
                  Underlay: form_data.underlay,
                  Notes: form_data.notes,
                  OriginalFile: form_data.images,
                  FileType: getFileExtension(form_data.images)
                },
              },
            ],
          };
  
          addToCartWithRetry(add_data)
            .then(function () {
              $('#custom_stickers_form').removeClass('loading');
              $.fn.updateCart();
              $('body').addClass('cart_open');
            })
            .catch(function (err) {
              var xhr = err.xhr;
              console.error('Error adding product to cart (after retries):', { status: xhr.status, responseJSON: xhr.responseJSON, responseText: xhr.responseText, sent: add_data });
              $('#custom_stickers_form').removeClass('loading');
            });
        },
        error: function(xhr, status, error) {
          console.error('AJAX request error:', error);
          $('#custom_stickers_form').removeClass('loading');
          
          let errorMessage = 'Error communicating with server';
          
          // Try to get a more specific error message
          try {
            if (xhr.responseText) {
              // Check if it contains a PHP error but also valid JSON at the end
              if (xhr.responseText.includes('<br />') && xhr.responseText.includes('{"status":')) {
                // Extract the JSON part from the end of the response
                const jsonStart = xhr.responseText.lastIndexOf('{');
                const jsonPart = xhr.responseText.substring(jsonStart);
                
                try {
                  const jsonResponse = JSON.parse(jsonPart);
                  if (jsonResponse.status === 'success' && jsonResponse.variant_id) {
                    // Continue with the normal process despite the PHP error
                    add_data = {
                      items: [
                        {
                          id: jsonResponse.variant_id,
                          quantity: 1,
                          properties: {
                            Image: form_data.images,
                            Quantity: form_data.qty,
                            Size: form_data.size,
                            Shape: form_data.shape,
                            Underlay: form_data.underlay,
                            Notes: form_data.notes,
                            OriginalFile: form_data.images,
                            FileType: getFileExtension(form_data.images)
                          },
                        },
                      ],
                    };
                    
                    addToCartWithRetry(add_data)
                      .then(function () {
                        $('#custom_stickers_form').removeClass('loading');
                        $.fn.updateCart();
                        $('body').addClass('cart_open');
                      })
                      .catch(function (err) {
                        var xhr2 = err.xhr;
                        console.error('Error adding product to cart (after retries):', { status: xhr2.status, responseJSON: xhr2.responseJSON, responseText: xhr2.responseText, sent: add_data });
                        $('#custom_stickers_form').removeClass('loading');
                      });
                    
                    return; // Exit the function without showing an error alert
                  }
                } catch (e) {}
              }
              
              // Check if it's JSON
              if (xhr.responseText.trim().startsWith('{')) {
                const errorResponse = JSON.parse(xhr.responseText);
                if (errorResponse.message) {
                  errorMessage = errorResponse.message;
                }
              } else if (xhr.responseText.trim().startsWith('<')) {
                // It's HTML, probably a PHP error
                errorMessage = 'Server error. Please try again later.';
              }
            }
          } catch (e) {}

          console.error(errorMessage);
        }
      });
    });
  });
  
  // Función para obtener la extensión del archivo
  function getFileExtension(url) {
    if (!url) return '';
    
    // Extraer la extensión del archivo
    const match = url.match(/\.([^./\\]+)$/);
    return match ? match[1].toLowerCase() : '';
  }
  
  // Función para verificar si el archivo es una imagen
  function isImageFile(fileType) {
    const imageTypes = ['png', 'jpg', 'jpeg', 'gif', 'webp'];
    return imageTypes.includes(fileType);
  }
  
  // Función para obtener la URL de la imagen a mostrar
  function getImageUrl(fileUrl) {
    const fileType = getFileExtension(fileUrl);
    
    // Si es una imagen, usar la URL original
    if (isImageFile(fileType)) {
      return fileUrl;
    }
    
    // Si no es una imagen, usar la imagen de placeholder con la extensión del archivo
    return 'https://dummyimage.com/500/f7f7f7/333&text=' + fileType.toUpperCase();
  }
  
  